<rk-modal-wrapper
  (closed)="dialogRef.close()"
  [title]="'SHARE.MODAL.SAVE_SUCCESS' | translate"
  [showSubmitBlock]="false"
>
  <div class="content">
    <mat-icon fontSet="fa" fontIcon="fa-check-circle"></mat-icon>
    <rk-input-with-copy
      [value]="data.widgetCode"
      [label]="'SHARE.FORM.NEW_INTEGRATION' | translate"
      [disableOpen]="true"
      [keepWidth]="true"
    ></rk-input-with-copy>
    <rk-colored-hint *ngIf="data.warning" [type]="'warning'">
      {{ data.warning }}
    </rk-colored-hint>
    <rk-button [label]="'SHARE.MODAL.CLOSE' | translate" (click)="close()"></rk-button>
  </div>
</rk-modal-wrapper>
